export const AXIOSNAMES = {
    DEFAULT: "basic",
    ONEMIN: "onemin",
    PRINT: "print"
};
